import { Suspense, lazy } from "react";
import { Navigate, useRoutes } from "react-router-dom";
import { useAuthCheck } from "../hooks/useAuthCheck";
import PreviewRouteGuard from "../components/preview/PreviewRouteGuard";
import {
  Home,
  Reporting,
  Desktop,
  Solutions,
  Integrations,
  Portal,
  Roadmap,
  Feedback,
  Sweepstakes,
  Investments,
  OAuthCallback,
  AutomationLabs,
  TechMentor,
  SystemBridge,
  OutageHub,
  Troubleshooting,
  ProjectExecution,
  ActualIntelligence,
  Onboarding,
  VendorOps,
  ClientIntelligence,
  LifecycleNavigator,
  Settings,
  Walkthrough,
  SystemMap,
  HowItWorks,
  Participation,
  Perspectives,
} from "./lazyRoutes";
import DashboardLayout from "../layouts/dashboard-layout/DashboardLayout";

const AdminShareLinks = lazy(() => import("../pages/admin/share-links"));

export default function Router() {
  const { isLoading, component } = useAuthCheck();

  const routes = useRoutes([
    { path: "/", element: <Home /> },
    { path: "/reporting", element: <Reporting /> },
    { path: "/desktop", element: <Desktop /> },
    { path: "/solutions", element: <Solutions /> },

    { path: "/solutions/automation-labs", element: <AutomationLabs /> },
    { path: "/solutions/system-bridge", element: <SystemBridge /> },
    { path: "/solutions/outage-hub", element: <OutageHub /> },
    { path: "/solutions/troubleshooting", element: <Troubleshooting /> },
    { path: "/solutions/tech-mentor", element: <TechMentor /> },
    { path: "/solutions/project-execution", element: <ProjectExecution /> },
    { path: "/solutions/actual-intelligence", element: <ActualIntelligence /> },
    { path: "/solutions/onboarding", element: <Onboarding /> },
    { path: "/solutions/vendor-ops", element: <VendorOps /> },
    { path: "/solutions/client-intelligence", element: <ClientIntelligence /> },
    { path: "/solutions/lifecycle-navigator", element: <LifecycleNavigator /> },

    { path: "/integrations", element: <Integrations /> },
    { path: "/portal", element: <Portal /> },
    { path: "/walkthrough", element: <Walkthrough /> },
    { path: "/system-map", element: <SystemMap /> },
    { path: "/perspectives", element: <Perspectives /> },
    { path: "/research/how-it-works", element: <HowItWorks /> },
    { path: "/research/participation", element: <Participation /> },
    { path: "/roadmap", element: <Roadmap /> },
    { path: "/feedback", element: <Feedback /> },
    { path: "/sweepstakes", element: <Sweepstakes /> },
    { path: "/investments", element: <Investments /> },
    { path: "/settings", element: <Settings /> },
    { path: "/admin/share-links", element: <AdminShareLinks /> },
    { path: "/oauth/callback", element: <OAuthCallback /> },
    { path: "*", element: <Navigate to="/" replace /> },
  ]);

  if (isLoading || component) {
    return component;
  }

  return (
    <DashboardLayout>
      <Suspense fallback={<div>Loading...</div>}>
        <PreviewRouteGuard>{routes}</PreviewRouteGuard>
      </Suspense>
    </DashboardLayout>
  );
}
